/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { OrgComplianceSettingsRequestCandidateNameDisplayMode } from './orgComplianceSettingsRequestCandidateNameDisplayMode';

/**
 * Body for ``PATCH /api/org/compliance-settings``.
 */
export interface OrgComplianceSettingsRequest {
  candidate_name_display_mode?: OrgComplianceSettingsRequestCandidateNameDisplayMode;
  show_candidate_photos?: boolean | null;
  show_profile_highlights?: boolean | null;
  show_insights_gender?: boolean | null;
  hidden_profile_highlight_ids?: string[] | null;
}
